import { Request } from './Request';

export class UpdateTeamNameRequest extends Request<never> {
  method = 'GET';
  url = '';

  constructor(teamName: string) {
    super();

    this.url = '/tc/teamupdate?team_name=' + teamName;
  }
}
